import { apiClientWithRefreshToken } from "@/api/apiClient";

export default async function DeletePurchaseOrder(id: string): Promise<void> {
    const res = await apiClientWithRefreshToken({
        url: `/purchase-orders/${id}`,
        method: "DELETE",
    });

    return res.data;
}
